module.exports = __webpack_public_path__ + "src/img/shuju_on.5b6977e0.svg";